export enum EnumFileExtension {
  HTML = 0,
  XML = 1,
  XSIG = 2,
  PDF = 3,
  XLSM = 4,
  XLSX = 5
}
